export const initialState = {
  link: '',
  isVisible: false,
  actionProcessing: false,
};
